import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/ClientProfiles/";

export function updateClientEmail(params, jwt) {
  return putUpdateClientEmailJwt(`${baseUrl}UpdateClientEmail`, params, jwt)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

function putUpdateClientEmailJwt(url, body, jwt) {
  let options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(body),
  };
  return fetch(url, options);
}

export function updateProfile(ClientId, params) {
  return apiUtils
    .put(`${baseUrl}UpdateProfile`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}